module.exports = __webpack_public_path__ + "static/media/HBPLinkIcon.bba66dc7.png";